import React from "react";
import { Button, InputField } from "../atoms";
import { PageBodyTitle } from "./PageBodyTitle";
import styled from "styled-components";
import { theme } from "../theme/semanticTheme";

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.xl};
`;

const PeriodGroup = styled.div`
  display: flex;
  gap: ${theme.spacing.xs};
`;

const DateGroup = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${theme.spacing.sm};

  & > div {
    min-width: 140px;
  }
`;

/**
 * Molecule: FilterBar – page title + period buttons + date range + action. Reusable for Overview, reports.
 */
export default function FilterBar({
  title = "Overview",
  periodOptions = [
    { value: null, label: "Daily" },
    { value: "WEEK", label: "Week" },
    { value: "MONTH", label: "Month" },
    { value: "YEAR", label: "Year" },
  ],
  selectedPeriod,
  onPeriodChange,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onApply,
  applyLabel = "GO",
}) {
  return (
    <Wrapper>
      <PageBodyTitle>{title}</PageBodyTitle>
      <PeriodGroup>
        {periodOptions.map((opt) => (
          <Button
            key={String(opt.value)}
            variant={selectedPeriod === opt.value ? "primary" : "secondary"}
            onClick={() => onPeriodChange(opt.value)}
          >
            {opt.label}
          </Button>
        ))}
      </PeriodGroup>
      <DateGroup>
        <InputField
          name="startDate"
          type="date"
          title="From Date"
          value={
            typeof startDate === "string"
              ? startDate
              : startDate
                ? startDate.toISOString?.()?.split("T")[0] ?? ""
                : ""
          }
          onChange={(val) => onStartDateChange(val ? new Date(val) : null)}
          max={new Date().toISOString().split("T")[0]}
        />
        <InputField
          name="endDate"
          type="date"
          title="To Date"
          value={
            typeof endDate === "string"
              ? endDate
              : endDate
                ? endDate.toISOString?.()?.split("T")[0] ?? ""
                : ""
          }
          onChange={(val) => onEndDateChange(val ? new Date(val) : null)}
          min={
            typeof startDate === "string"
              ? startDate
              : startDate
                ? startDate.toISOString?.()?.split("T")[0]
                : undefined
          }
          max={new Date().toISOString().split("T")[0]}
          disabled={!startDate}
        />
        <Button variant="primary" onClick={onApply}>
          {applyLabel}
        </Button>
      </DateGroup>
    </Wrapper>
  );
}
